import { render, staticRenderFns } from "./InvitationNotification.vue?vue&type=template&id=40999475"
import script from "./InvitationNotification.vue?vue&type=script&lang=js"
export * from "./InvitationNotification.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports